import React, { useState, useRef, useEffect } from "react";
import {
  parsePpeResponse,
  ppePricingUrl,
  ppeAuthHeaders,
} from "../../config";
import { calculateLoanMetrics, getCollateralValue } from "../../loanMetrics";
import { formatPpeSearchParams } from "../../pricingRequest";
import "./index.css";
import {
  Slider,
  Table,
  Tabs,
  ConfigProvider,
  Select,
  Input,
  InputNumber,
  message,
  Empty,
  Tooltip,
  Dropdown,
  Checkbox,
} from "antd";
import * as com from "../../../../Common.js";
import AutoProgress from "../../../../DocumentChecklist/AutoProgress";
import { CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import RateQuoteNewResultTable from "../../RateQuoteNewResultTable";
import { lender } from "State";
import { set } from "lodash";
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'
// PPE: ARM terms are fixed period + adjustment cadence (3/1 ... 10/6); older
// fixed-period-only saved searches restore as the N/6 product.
import {
  ARM_TERM_OPTIONS,
  ARM_TERM_YEARS,
  DEFAULT_ARM_TERM,
  restoreArmTerm,
} from "../../armTerms";

const FIXED_TERM_OPTIONS = [
  { value: "fixed40", label: "Fixed 40 Year" },
  { value: "fixed30", label: "Fixed 30 Year" },
  { value: "fixed25", label: "Fixed 25 Year" },
  { value: "fixed20", label: "Fixed 20 Year" },
  { value: "fixed15", label: "Fixed 15 Year" },
  { value: "fixed10", label: "Fixed 10 Year" },
];
const SECOND_LIEN_PROGRAMS = ["heloc", "secondMortgage"];

// 添加防抖函数
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};


const SearchResults = ({
  searchParams,
  customerid,
  loading,
  setLoading,
  search,
  setChangeShowResults,
  onRefineSearch,
  style,
  searchSource = 'check_rates',
}) => {
  const searchSourceLatest = useRef(searchSource)
  searchSourceLatest.current = searchSource
  // filter
  const [activeTab, setActiveTab] = useState("1");
  const [searchBy, setSearchBy] = useState("price");
  const [searchByFlag, setSearchByFlag] = useState("price");
  const [targetPrice, setTargetPrice] = useState(0);
  const [targetPriceSlider, setTargetPriceSlider] = useState(0);
  const [isTargetPriceFocus, setIsTargetPriceFocus] = useState(false);
  const [compType, setCompType] = useState();
  const [propertyValue, setPropertyValue] = useState(0);
  const [propertyValueSlider, setPropertyValueSlider] = useState(0);
  const [isPropertyValueFocus, setIsPropertyValueFocus] = useState(false);
  const [downPayment, setDownPayment] = useState(0);
  const [downPaymentSlider, setDownPaymentSlider] = useState(0);
  const [isDownPaymentFocus, setIsDownPaymentFocus] = useState(false);
  const [loanAmount, setLoanAmount] = useState(0);
  const [loanAmountSlider, setLoanAmountSlider] = useState(0);
  const [isLoanAmountFocus, setIsLoanAmountFocus] = useState(false);
  const [loanType, setLoanType] = useState([""]);
  const [loanTypeFilter, setLoanTypeFilter] = useState([""]);
  const [loanTerms, setLoanTerms] = useState();
  const [amort, setAmort] = useState("fixed");
  const [lenders, setLenders] = useState([]);

  // table
  const [eligible_data, setEligibleData] = useState([]);
  const [ineligible_data, setIneligibleData] = useState([]);
  const [selectedRates, setSelectedRates] = useState([]);
  const [connectedLendersMap, setConnectedLendersMap] = useState({});
  const [resultlenderSet, setResultlenderSet] = useState(new Set());
  const [lenderData, setLenderData] = useState([]);
  const [selectedLenders, setSelectedLenders] = useState([]);
  // Pre-select only the customer's connected lenders; the rest stay under
  // "Products from other lenders" for the LO to opt into. This is passed to
  // RateQuoteNewResultTable as selectedLendersFromFilter and overrides its own
  // (also connected-only) default, so the two must agree.
  const [showConnectedLendersOnly, setShowConnectedLendersOnly] =
    useState(true);
  const [showIneligible, setShowIneligible] = useState(false);
  const [showAddLendersModal, setShowAddLendersModal] = useState(false);
  const [ineligibleProducts, setIneligibleProducts] = useState({});
  const [noProducts, setNoProducts] = useState(false);
  const [productTypes, setProductTypes] = useState([]);
  const [loans, setLoans] = useState([]);
  const [indexFixed30, setIndexFixed30] = useState(0);
  const [indexFixed25, setIndexFixed25] = useState(0);
  const [indexFixed20, setIndexFixed20] = useState(0);
  const [indexFixed15, setIndexFixed15] = useState(0);
  const [indexFixed10, setIndexFixed10] = useState(0);
  const [indexArm56, setIndexArm56] = useState(0);
  const [indexArm76, setIndexArm76] = useState(0);
  const [indexArm106, setIndexArm106] = useState(0);
  const [selectedAUS, setSelectedAUS] = useState([]);
  const [allRates, setAllRates] = useState({});
  const [finalParams, setFinalParams] = useState({});
  const [flag, setFlag] = useState(0);

  // 产品类型映射
  const productTypesMap = {
    Conventional: ["CONV", "CONV_HIGH_BALANCE"],
    FHA: ["FHA"],
    VA: ["VA"],
    USDA: ["USDA"],
    Jumbo: ["JUMBO"],
  };

  let isComponentMounted = true;

  useEffect(() => {
    return () => {
      isComponentMounted = false;
    };
  }, []);

  useEffect(() => {
    if (searchParams) {
      // console.log("searchParams--changeed-----", searchParams);
      setSearchBy(searchParams.searchBy);
      setSearchByFlag(searchParams.searchBy);
      setTargetPrice(
        searchParams.searchBy === "price"
          ? searchParams.targetPrice
          : searchParams.targetRate
      );
      setTargetPriceSlider(
        searchParams.searchBy === "price"
          ? searchParams.targetPrice
          : searchParams.targetRate
      );

      setCompType(searchParams.compensationType);

      setPropertyValue(searchParams.propertyValue);
      setPropertyValueSlider(searchParams.propertyValue);

      const initialDownPayment = searchParams.purpose === "Purchase"
        ? searchParams.downPayment
        : undefined;
      setDownPayment(initialDownPayment);
      setDownPaymentSlider(initialDownPayment);

      setLoanAmount(searchParams.loanAmount);
      setLoanAmountSlider(searchParams.loanAmount);

      setLoanType(searchParams.loanType || searchParams.loanTypes);
      setLoanTerms(restoreArmTerm(searchParams.loanTerm));
      setAmort(
        String(searchParams.loanTerm || "").startsWith("arm")
          ? "arm"
          : "fixed"
      );

      // setLenders(searchParams.lenders);

      // debouncedFetchData();
      // setFinalParams(formatSearchParams(searchParams));
      setFlag(searchParams._timestamp);
    }
  }, [searchParams]);

  // 创建一个防抖的fetchData函数
  const debouncedFetchData = useRef(
    debounce(() => {
      fetchData();
    }, 500)
  ).current;

  // 创建一个防抖的setFinalParams函数
  const debouncedSetFinalParams = useRef(
    debounce((params) => {
      setFinalParams(params);
    }, 1500)
  ).current;

  // The quick filter owns Home Value / Loan Amount once either is edited. Keep
  // every dependent wire value in the same snapshot so a previously-invalid
  // refi (LTV > 100) cannot leave stale LTV/CLTV/HCLTV or appraisedValue behind.
  const getFilterLoanMetrics = () => {
    const property = Number(propertyValue) || 0;
    const appraisal = Number(searchParams.appraisedValue) || property;
    const value = getCollateralValue({
      loanPurpose: searchParams.purpose,
      propertyValue: property,
      appraisedValue: appraisal,
    });
    const program = searchParams.loanProgram;
    const isSecondLienProgram = SECOND_LIEN_PROGRAMS.includes(program);
    const baseLoanAmount = program === "heloc"
      ? Number(searchParams.drawAmount) || 0
      : (isSecondLienProgram
          ? Number(loanAmount) || 0
          : (searchParams.purpose === "Purchase"
              ? property - (Number(downPayment) || 0)
              : (Number(loanAmount) || 0)));
    if (value <= 0) {
      return { baseLoanAmount, ltv: undefined, cltv: undefined, hcltv: undefined };
    }

    const metrics = calculateLoanMetrics({
      loanProgram: program,
      loanPurpose: searchParams.purpose,
      propertyValue: property,
      appraisedValue: appraisal,
      loanAmount: baseLoanAmount,
      secondaryLoanAmount: searchParams.secondaryLoanAmount,
      primaryMortgageAmount: searchParams.primaryMortgageAmount,
      lineAmount: searchParams.lineAmount,
      drawAmount: searchParams.drawAmount,
    });
    return {
      baseLoanAmount,
      ltv: metrics.ltv,
      cltv: metrics.cltv,
      hcltv: metrics.hcltv,
    };
  };

  useEffect(() => {
    // console.log('-------filter params changed-------', searchParams)
    // debouncedFetchData();
    const metrics = getFilterLoanMetrics();
    const secondLienProgram = SECOND_LIEN_PROGRAMS.includes(searchParams.loanProgram);
    debouncedSetFinalParams(formatPpeSearchParams({ ...searchParams,
      searchBy,
      // [searchParams.searchBy === "price" ? 'targetPrice' : 'targetRate']: targetPrice,
      targetRate: searchBy === "price" ? searchParams.targetPrice : targetPrice,
      targetPrice: searchBy === "rate" ? searchParams.targetRate : targetPrice,
      compensationType: compType,
      propertyValue,
      // On a refinance the filter labels this field Home Value; it is also the
      // appraisal/collateral value used by the pricing engine.
      appraisedValue: searchParams.purpose === "Purchase"
        ? searchParams.appraisedValue
        : propertyValue,
      downPayment: !secondLienProgram && searchParams.purpose === 'Purchase' ? downPayment : undefined,
      loanAmount: metrics.baseLoanAmount,
      totalLoanAmount: secondLienProgram
        ? undefined
        : metrics.baseLoanAmount + (Number(searchParams.secondaryLoanAmount) || 0),
      secondaryLoanAmount: secondLienProgram ? undefined : searchParams.secondaryLoanAmount,
      LTV: metrics.ltv,
      CLTV: metrics.cltv,
      HCLTV: metrics.hcltv,
      // Clear old manual overrides by replacing them with the newly-derived
      // ratios; formatSearchParams treats these as the final wire values.
      cltvInput: metrics.cltv,
      hcltvInput: metrics.hcltv,
      loanType,
      loanTerms,
      // Quick-filter overrides under the WIRE field names — formatSearchParams
      // reads loanTerm/amortizationType, not the legacy loanTerms key.
      loanTerm: loanTerms || searchParams?.loanTerm,
      amortizationType: amort,
      armFixedTerm: ARM_TERM_YEARS[loanTerms] || searchParams?.armFixedTerm,
      lenders,
    }));
  }, [
    flag,
    searchBy,
    targetPrice,
    compType,
    propertyValue,
    downPayment,
    loanAmount,
    // loanType,
    loanTerms,
    amort,
    lenders,
  ]);

  useEffect(() => {
    // PPE: disable the client-side loan-type filter. Program selection now comes
    // from loanProgram and the backend already returns only that program's
    // products; a second client filter here would wrongly empty the results.
    setLoanTypeFilter([""]);
  }, [loanType]);

  // FORKED for PPE: map the Rates SearchFields body (engine-style enums) to the
  // new unified endpoint's PricingRequest. Enum VALUES are passed as-is; the
  // backend DTO maps accept both engine-style ("PRIMARY", "Purchase") and
  // camelCase. New QM+NonQM-specific fields flow through sp.nonQm / sp.loanProgram
  // once the forked search fields collect them (stage 2); for now loanProgram is
  // derived from the selected loan types.

  const fetchData = () => {
    setLoading(true);

    // mock params
    // const params = JSON.parse(
    //   `{"state":"CALIFORNIA","county":"ALAMEDA COUNTY","purpose":"Purchase","loanAmount":400000,"units":1,"LTV":80,"CLTV":80,"HCLTV":80,"FICO":780,"occupancy":"PRIMARY","property":"SINGLE_FAMILY_DETACHED","point":[{"lender":"default","percent":1,"fixed":500}],"estimatedClosingCosts":40,"pmi":0.51,"getFiles":false,"monthlyIncome":10000,"monthlyDebt":1000,"firsttimehomebuyer":true,"selfemployed":false,"citizenship":"US_CITIZENS","visaType":"H_1B","numberOfOwnedProperties":1,"escrowWaiver":true,"appraisalWaiver":false,"currentJobInMonths":24,"rsuAsIncome":-1,"giftFundUsed":false,"familyRelatedOrSmallBusiness":false,"borrowerPaidCompensationAmount":0,"dti":10,"Rate_LMIBAdjustment":false,"Rate_LMITAdjustment":false,"Rate_MMCTAdjustment":false,"Rate_CRAAdjustment":false}`
    // );

    // console.log(
    //   "formatSearchParams(searchParams)",
    //   formatSearchParams(searchParams)
    // );

    // 找出 params和 formatSearchParams(searchParams) 的差异
    // const diff = Object.keys(formatSearchParams(searchParams)).filter(
    //   (key) => params[key] !== formatSearchParams(searchParams)[key]
    // );
    // console.log("diff", diff);

    // return
    fetch(ppePricingUrl(), {
      method: "POST",
      headers: ppeAuthHeaders(),
      body: JSON.stringify(formatPpeSearchParams(searchParams).pricingRequest),
    })
      .then(parsePpeResponse)
      .then((prd) => {
        // if (prd.status === "Internal Error") {
        //   setLoading(false);
        //   message.error(prd.message);
        //   return;
        // }
        if (prd.status !== "Ok") {
          setLoading(false);
          message.error(prd.message);
          return;
        }
        track(STATSIG.RATES.SEARCH, { source: searchSourceLatest.current || 'check_rates' })
        // console.log("lender data:", prd);
        const noLendersAdded = Object.values(prd.connected_lender_map).every(
          (value) => value === false
        );
        setConnectedLendersMap(prd.connected_lender_map);

        let products = prd.result;
        let prTypesSet = new Set();

        if (products !== undefined) {
          let lenderSet = new Set();
          products.forEach((product) => {
            lenderSet.add(product.Lender);
          });
          setResultlenderSet(lenderSet);

          const data = Array.from(lenderSet)
            .map((lender) => ({
              label: com.formatLenderDisplayName(lender),
              value: lender,
              myLenders: prd.connected_lender_map[lender] || false,
            }))
            .sort((a, b) => b.myLenders - a.myLenders);

          // console.log("data", data);

          setLenderData(data);
          setSelectedLenders(
            showConnectedLendersOnly
              ? Array.from(lenderSet).filter((x) => prd.connected_lender_map[x])
              : Array.from(lenderSet)
          );

          if (noLendersAdded) {
            setShowConnectedLendersOnly(false);
            setShowIneligible(false);
            setShowAddLendersModal(true);
            setSelectedLenders(Array.from(lenderSet));
          }
        }

        if (prd.ineligible_reasons != undefined) {
          let ine = {};
          for (let key in prd.connected_lender_map) {
            if (prd.connected_lender_map[key]) {
              if (prd.ineligible_reasons[key]) {
                ine[key] = prd.ineligible_reasons[key];
              }
            }
          }
          setIneligibleProducts(ine);
        } else {
          setIneligibleProducts({});
        }

        if (products === undefined) {
          setNoProducts(true);
          setShowIneligible(true);
          if (prd.message === "can not get lender fee data") {
            setShowIneligible(false);
            setShowAddLendersModal(true);
          }
          setLoading(false);
          return;
        } else {
          setNoProducts(false);
        }

        // 处理产品数据
        let fixed40 = [],
          fixed30 = [],
          fixed25 = [],
          fixed20 = [],
          fixed15 = [],
          fixed10 = [];
        let arm56 = [],
          arm76 = [],
          arm106 = [],
          arm31 = [];

        products.forEach((product) => {
          let lender = product.Lender;
          let fb = product.FileB;

          product.ProductRatesCosts.forEach((pr) => {
            let commonproduct = pr.product;
            let adjustments = pr.appliedAdjustments;
            let ausengine = pr.AUSEngine;

            if (showConnectedLendersOnly && !noLendersAdded) {
              if (prd.connected_lender_map[lender]) {
                prTypesSet.add(commonproduct.Mtype);
              }
            } else {
              prTypesSet.add(commonproduct.Mtype);
            }

            pr.rateCosts.forEach((rate) => {
              let pdkt = {
                Lender: lender,
                ...commonproduct,
                Aus: ausengine,
                ...rate,
                Adjustments: adjustments,
                FileB: fb,
              };

              //   if (rate?.lockDay !== searchParams?.lockDay) {
              //     return;
              //   }

              // No AUS list on the product = compatible with any AUS (engine
              // semantics); .includes on a null Aus threw and the fetch
              // .catch blanked the page.
              if (Array.isArray(pdkt.Aus) && pdkt.Aus.length > 0) {
                let commonAUS = selectedAUS.filter((val) =>
                  pdkt.Aus.includes(val.label)
                );
                if (commonAUS.length === 0) {
                  return;
                }
              }

              const filterPdkt = () => {
                if (
                  customerid === "siliconcitymortgage" &&
                  pdkt.Mtype.includes("FHA")
                ) {
                  return false;
                }
                return true;
              };

              pdkt.loanAmount = Number(
                searchParams.drawAmount ??
                searchParams.pricingRequest?.baseLoanAmount ??
                searchParams.baseLoanAmount ??
                searchParams.lineAmount ??
                searchParams.loanAmount
              ) || 0;

              if (filterPdkt()) {
                if (pdkt.Arm != null) {
                  if (pdkt.Arm.fixedperiod == 5) {
                    arm56.push(pdkt);
                  } else if (pdkt.Arm.fixedperiod == 7) {
                    arm76.push(pdkt);
                  } else if (pdkt.Arm.fixedperiod == 10) {
                    arm106.push(pdkt);
                  } else if (pdkt.Arm.fixedperiod == 3) {
                    arm31.push(pdkt);
                  }
                } else {
                  if (pdkt.Term == 40) {
                    fixed40.push(pdkt);
                  } else if (pdkt.Term == 30) {
                    fixed30.push(pdkt);
                  } else if (pdkt.Term == 25) {
                    fixed25.push(pdkt);
                  } else if (pdkt.Term == 20) {
                    fixed20.push(pdkt);
                  } else if (pdkt.Term == 15) {
                    fixed15.push(pdkt);
                  } else if (pdkt.Term == 10) {
                    fixed10.push(pdkt);
                  }
                }
              }
            });
          });
        });

        // 排序和筛选利率
        let compareRate = (a, b) => {
          if (a.base_rate !== b.base_rate) return a.base_rate - b.base_rate;
          return a.closing_cost - b.closing_cost;
        };

        let cullRate = (products) => {
          const filteredPrds = products.filter((p) => p.lender_credit > 0);
          if (filteredPrds.length === 0) return filteredPrds;

          let newproducts = [];
          newproducts.push(filteredPrds[0]);
          let base_rate = filteredPrds[0].base_rate;
          let closing_cost = filteredPrds[0].closing_cost;

          for (let i = 1; i < filteredPrds.length; i++) {
            if (filteredPrds[i].base_rate !== base_rate) {
              if (filteredPrds[i].closing_cost < closing_cost) {
                newproducts.push(filteredPrds[i]);
                closing_cost = filteredPrds[i].closing_cost;
              }
              base_rate = filteredPrds[i].base_rate;
            }
          }
          return newproducts;
        };

        let getIndex = (loans) => {
          let bestIndex = 0;
          let bestPoints = 1000000;
          for (let i = 0; i < loans.length; i++) {
            if (Math.abs(loans[i].lender_credit - 1500) < bestPoints) {
              bestPoints = Math.abs(loans[i].lender_credit - 1500);
              bestIndex = i;
            }
          }
          return bestIndex;
        };

        // 更新产品类型
        let matchingProductTypes = (arr) => {
          let detectedTypes = [];
          for (let type of arr) {
            for (let key of Object.keys(productTypesMap)) {
              if (productTypesMap[key].includes(type)) {
                detectedTypes.push(key);
              }
            }
          }
          setProductTypes(detectedTypes);
        };

        matchingProductTypes(Array.from(prTypesSet));

        // 设置所有利率
        setAllRates({
          fixed40,
          fixed30,
          fixed25,
          fixed20,
          fixed15,
          fixed10,
          arm56,
          arm76,
          arm106,
          arm31,
        });

        // 排序和筛选
        fixed40.sort(compareRate);
        fixed30.sort(compareRate);
        fixed25.sort(compareRate);
        fixed20.sort(compareRate);
        fixed15.sort(compareRate);
        fixed10.sort(compareRate);
        arm56.sort(compareRate);
        arm76.sort(compareRate);
        arm106.sort(compareRate);
        arm31.sort(compareRate);

        fixed40 = cullRate(fixed40);
        fixed30 = cullRate(fixed30);
        fixed25 = cullRate(fixed25);
        fixed20 = cullRate(fixed20);
        fixed15 = cullRate(fixed15);
        fixed10 = cullRate(fixed10);
        arm56 = cullRate(arm56);
        arm76 = cullRate(arm76);
        arm106 = cullRate(arm106);
        arm31 = cullRate(arm31);

        // 设置最佳利率索引
        setIndexFixed30(getIndex(fixed30));
        setIndexFixed25(getIndex(fixed25));
        setIndexFixed20(getIndex(fixed20));
        setIndexFixed15(getIndex(fixed15));
        setIndexFixed10(getIndex(fixed10));
        setIndexArm56(getIndex(arm56));
        setIndexArm76(getIndex(arm76));
        setIndexArm106(getIndex(arm106));

        // 设置默认贷款
        const firstNonEmpty = [fixed30, arm56, arm76, arm106, arm31,
          fixed25, fixed20, fixed15, fixed10, fixed40].find((b) => b.length !== 0);
        if (firstNonEmpty) {
          setLoans(firstNonEmpty);
        }

        setLoading(false);
      })
      .catch((err) => {
        message.error(err.message || "An internal error has occurred");
        console.log("fetchData error", err);
        setLoading(false);
      });
  };

  const suffix_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.8425 8.7999L13.9587 7.91602L10.129 11.7457L6.30088 7.91755L5.41699 8.80143L9.24512 12.6296L9.24461 12.6301L10.1285 13.5139L10.129 13.5134L10.131 13.5155L11.0149 12.6316L11.0129 12.6296L14.8425 8.7999Z"
          fill="#6E6E70"
        />
      </svg>
    );
  };

  const compare_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5085 3.12562C11.7607 3.2301 11.9252 3.47623 11.9252 3.74924V4.57424H12.0002C13.2014 4.57424 14.1752 5.54803 14.1752 6.74924V9.9025C15.4652 10.2072 16.4252 11.3661 16.4252 12.7492C16.4252 14.3647 15.1157 15.6742 13.5002 15.6742C11.8847 15.6742 10.5752 14.3647 10.5752 12.7492C10.5752 11.3661 11.5352 10.2072 12.8252 9.9025V6.74924C12.8252 6.2936 12.4558 5.92424 12.0002 5.92424H11.9252V6.74924C11.9252 7.02225 11.7607 7.26838 11.5085 7.37286C11.2563 7.47733 10.9659 7.41958 10.7729 7.22654L9.2729 5.72654C9.00929 5.46293 9.00929 5.03555 9.2729 4.77194L10.7729 3.27194C10.9659 3.07889 11.2563 3.02114 11.5085 3.12562ZM13.5002 11.1742C12.6303 11.1742 11.9252 11.8794 11.9252 12.7492C11.9252 13.6191 12.6303 14.3242 13.5002 14.3242C14.3701 14.3242 15.0752 13.6191 15.0752 12.7492C15.0752 11.8794 14.3701 11.1742 13.5002 11.1742Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5752 5.99922C1.5752 4.38379 2.88477 3.07422 4.5002 3.07422C6.11562 3.07422 7.42519 4.38379 7.42519 5.99922C7.42519 7.38233 6.46521 8.54122 5.17519 8.84595V11.9992C5.17519 12.4549 5.54455 12.8242 6.00019 12.8242H6.07519V11.9992C6.07519 11.7262 6.23965 11.4801 6.49188 11.3756C6.74411 11.2711 7.03444 11.3289 7.22749 11.5219L8.72749 13.0219C8.9911 13.2855 8.9911 13.7129 8.72749 13.9765L7.22749 15.4765C7.03444 15.6696 6.74411 15.7273 6.49188 15.6228C6.23965 15.5184 6.07519 15.2722 6.07519 14.9992V14.1742H6.00019C4.79898 14.1742 3.8252 13.2005 3.8252 11.9992V8.84595C2.53518 8.54122 1.5752 7.38233 1.5752 5.99922ZM4.5002 4.42422C3.63035 4.42422 2.9252 5.12937 2.9252 5.99922C2.9252 6.86906 3.63035 7.57422 4.5002 7.57422C5.37004 7.57422 6.07519 6.86906 6.07519 5.99922C6.07519 5.12937 5.37004 4.42422 4.5002 4.42422Z"
          fill="white"
        />
      </svg>
    );
  };

  const targetPriceUpdateRef = useRef(null);
  const propertyValueUpdateRef = useRef(null);
  const downPaymentUpdateRef = useRef(null);
  const loanAmountUpdateRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isTargetPriceFocus &&
        targetPriceUpdateRef.current &&
        !targetPriceUpdateRef.current.contains(event.target)
      ) {
        setIsTargetPriceFocus(false);
      }
      if (
        isPropertyValueFocus &&
        propertyValueUpdateRef.current &&
        !propertyValueUpdateRef.current.contains(event.target)
      ) {
        setIsPropertyValueFocus(false);
      }
      if (
        isDownPaymentFocus &&
        downPaymentUpdateRef.current &&
        !downPaymentUpdateRef.current.contains(event.target)
      ) {
        setIsDownPaymentFocus(false);
      }
      if (
        isLoanAmountFocus &&
        loanAmountUpdateRef.current &&
        !loanAmountUpdateRef.current.contains(event.target)
      ) {
        setIsLoanAmountFocus(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTargetPriceFocus, isPropertyValueFocus, isDownPaymentFocus, isLoanAmountFocus]);

  //   filter
  const targetPriceChange = (value) => {
    setTargetPrice(value);
  };
  const compTypeChange = (value) => {
    setCompType(value);
  };
  const propertyValueSliderChange = (value) => {
    setPropertyValueSlider(value);
  };
  const downPaymentSliderChange = (value) => {
    setDownPaymentSlider(value);
  };
  const loanAmountSliderChange = (value) => {
    setLoanAmountSlider(value);
  };
  const loanTermsChange = (value) => {
    setLoanTerms(value);
  };
  const amortChange = (value) => {
    setAmort(value);
    if (value === "arm") {
      if (!String(loanTerms).startsWith("arm")) {
        setLoanTerms(DEFAULT_ARM_TERM);
      }
    } else if (value === "fixed" && !String(loanTerms).startsWith("fixed")) {
      setLoanTerms("fixed30");
    }
  };
  const lendersChange = (value) => {
    setLenders(value);
  };
  const targetPriceSliderChange = (value) => {
    setTargetPriceSlider(value);
  };

  // table
  const tabItems = [
    {
      key: "1",
      label: () => {
        return (
          <div>
            Eligible{" "}
            <span
              className={
                "rates-count " + (activeTab === "1" ? "active" : "inactive")
              }
            >
              {eligible_data.length || 0}
            </span>
          </div>
        );
      },
    },
    {
      key: "2",
      label: () => {
        return (
          <div>
            Ineligible{" "}
            <span
              className={
                "rates-count " + (activeTab === "2" ? "active" : "inactive")
              }
            >
              {ineligible_data.length || 0}
            </span>
          </div>
        );
      },
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  const columns = [
    {
      type: "checkbox",
      key: "checkbox",
    },
    {
      title: "Lender & Product",
      dataIndex: "lender",
      key: "lender",
    },
    {
      title: "Rate /APR",
      dataIndex: "rate",
      key: "rate",
    },
    { title: "LLPA", dataIndex: "llpa", key: "llpa" },
    { title: "Comp. type", dataIndex: "comp_type", key: "comp_type" },
    { title: "Final price", dataIndex: "final_price", key: "final_price" },
    { title: "Closing cost", dataIndex: "closing_cost", key: "closing_cost" },
    { title: "PMT", dataIndex: "pmt", key: "pmt" },
  ];

  const maincolumns = [
    {
      title: "Lender & Product",
      dataIndex: "program",
      key: "program",
      width: "150px",
      className: "outerRateColumn",
      render: (_, record) => <div>{_}</div>,
      sorter: (a, b) => a.program.localeCompare(b.program),
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      width: "70px",
      className: "outerRateColumn",
      render: (_, record) => <div>{_}</div>,
      sorter: (a, b) => {
        return a.rate - b.rate;
      },
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "PMT",
      dataIndex: "monthlypay",
      key: "monthlypay",
      width: "90px",
      className: "outerRateColumn",
      render: (_, record) => <div>{_}</div>,
      sorter: (a, b) => a.monthlypay - b.monthlypay,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: (
        <Tooltip title="The adjusted price is calculated by adding the price adjustment points to the lock day price.">
          <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img src="/images/rates-price-icon.svg" />
            <span>Price</span>
          </div>
        </Tooltip>
      ),
      dataIndex: "originalprice",
      key: "originalprice",
      width: "130px",
      className: "outerRateColumn",
      render: (_, record) => <div>{_}</div>,
      sorter: (a, b) => a.originalprice - b.originalprice,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: (
        <Tooltip title='The compensation point established on the "Lenders" page.'>
          LO. Comp.
        </Tooltip>
      ),
      dataIndex: "compensationprice",
      key: "compensationprice",
      width: "110px",
      className: "outerRateColumn",
      render: (_, record) => <div>{_}</div>,
      sorter: (a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ["descend", "ascend", "descend"],
    },

    {
      title: (
        <Tooltip title="The total price is the sum of the lock day price, adjustment points, and compensation points.">
          Net pricing
        </Tooltip>
      ),
      dataIndex: "points",
      key: "points",
      width: "120px",
      className: "outerRateColumn",
      render: (_, record) => <div>{_}</div>,
      sorter: (a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ["ascend", "descend", "ascend"],
    },
  ];

  const handleChangeSelectedlenders = (value) => {
    // 验证所有选中的值是否在 lenderData 中存在
    const validValues = value.filter(v => 
      lenderData.some(item => item.value === v)
    );
    
    setSelectedLenders(validValues);
  };

  // 在组件顶部添加必要的状态和 ref
  const [isLendersFocus, setIsLendersFocus] = useState(false);
  const lendersUpdateRef = useRef(null);

  // 在 useEffect 中添加点击外部关闭的处理
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isLendersFocus &&
        lendersUpdateRef.current &&
        !lendersUpdateRef.current.contains(event.target)
      ) {
        setIsLendersFocus(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLendersFocus]);

  const [openLender, setOpenLender] = useState(false);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const closeLender = () => {
    setOpenLender(false);
  };

  const handleLenderDropdown = (flag) => {
    setOpenLender(flag);
  };

  const selectAll = (type) => {
    const isMyLenders = type === "my";
    const selectedLendersForType = lenderData
      .filter((item) => item.myLenders === isMyLenders)
      .map((item) => item.value);
    setSelectedLenders((prevSelected) => {
      const isAllSelected = selectedLendersForType.every((item) =>
        prevSelected.includes(item)
      );
      if (isAllSelected) {
        return prevSelected.filter(
          (item) => !selectedLendersForType.includes(item)
        );
      } else {
        return Array.from(
          new Set([...prevSelected, ...selectedLendersForType])
        );
      }
    });
  };

  const clearAll = () => {
    setSelectedLenders([]);
  };

  const lenderDropdownContent = () => {
    return (
      <div className="document-lender-content" style={{ width: 410 }}>
        <div className="lender-title">
          <span>Lenders</span>
          <div className="close-lender-box">
            <CloseOutlined className="close-lender" onClick={closeLender} />
          </div>
        </div>
        <div className="lender-select" style={{height: screenHeight >= 768 ? 560 : 380, overflowY: 'scroll'}}>
          <Checkbox.Group
            className="filter-checkbox-group"
            style={{
              width: "100%",
            }}
            value={selectedLenders}
            // onChange={handleChangeSelectedlenders}
          >
            <div style={{ width: "100%" }}>
              <div className="lender-select-item-title">
                <div className="select-title">My lenders</div>
                <div className="select-all" onClick={() => selectAll("my")}>
                  Select all
                </div>
              </div>
              {lenderData
                .filter((item) => item.myLenders)
                .map((item, index) => (
                  <div
                    style={{
                      height: 42,
                      display: "flex",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <Checkbox className="lender-checkbox" value={item.value} onChange={(e) => {
                      // console.log('-----check', e)
                      if(e.target.checked){
                        !selectedLenders.includes(item.value) && handleChangeSelectedlenders([...selectedLenders, item.value]);
                      }else{
                        selectedLenders.includes(item.value) && handleChangeSelectedlenders(selectedLenders.filter(v => v !== item.value));
                      }
                    }}>
                      <span className="lender-checkbox-label">
                        {item.label}
                      </span>
                    </Checkbox>
                  </div>
                ))}
              {lenderData.filter((item) => !item.myLenders).length > 0 && (
                <div
                  style={{ marginTop: 32 }}
                  className="lender-select-item-title"
                >
                  <div className="select-title">
                    <span>Products from other lenders</span>
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: 2,
                      }}
                    >
                      <Tooltip
                        placement="top"
                        title="Explore competitive rates from Zeitro's partner lenders. Connect directly to learn more and get started."
                      >
                        <QuestionCircleOutlined
                          style={{ fontSize: 14, cursor: "pointer" }}
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <div
                    className="select-all"
                    onClick={() => selectAll("other")}
                  >
                    Select all
                  </div>
                </div>
              )}
              {lenderData
                .filter((item) => !item.myLenders)
                .map((item, index) => (
                  <div
                    style={{
                      height: 42,
                      display: "flex",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <Checkbox className="lender-checkbox" value={item.value} 
                    onChange={(e) => {
                      // console.log('-----check', e)
                      if(e.target.checked){
                        !selectedLenders.includes(item.value) && handleChangeSelectedlenders([...selectedLenders, item.value]);
                      }else{
                        selectedLenders.includes(item.value) && handleChangeSelectedlenders(selectedLenders.filter(v => v !== item.value));
                      }
                    }}
                    >
                      <span className="lender-checkbox-label">
                        {item.label}
                      </span>
                    </Checkbox>
                  </div>
                ))}
            </div>
          </Checkbox.Group>
        </div>
        <div className="lender-action">
          <div className="lender-clear" onClick={clearAll}>
            Clear
          </div>
        </div>
      </div>
    );
  };

  const handleRefineSearch = () => {
    // 把参数回传给searchFields
    // console.log('--refine search', loanAmount, propertyValue, downPayment)
    const secondLienProgram = SECOND_LIEN_PROGRAMS.includes(searchParams.loanProgram);
    const params = {
      ...searchParams,
      searchBy: searchBy,
      compensationType: compType,
      propertyValue: propertyValue,
      downPayment: !secondLienProgram && searchParams.purpose === 'Purchase' ? downPayment : undefined,
      loanAmount: loanAmount,
      loanType: loanType,
      loanTerm: loanTerms,
      amortizationType: amort,
      armFixedTerm: ARM_TERM_YEARS[loanTerms] || searchParams?.armFixedTerm || 5,
      lenders: selectedLenders,
      // LTV: (loanAmount / propertyValue) * 100,
    }
    if (secondLienProgram) {
      const metrics = getFilterLoanMetrics();
      params.loanAmount = metrics.baseLoanAmount;
      params.LTV = metrics.ltv;
      params.CLTV = metrics.cltv;
      params.HCLTV = metrics.hcltv;
      params.totalLoanAmount = undefined;
      params.secondaryLoanAmount = undefined;
    } else if(searchParams.purpose === 'Purchase'){
      params.LTV = (propertyValue - downPayment) / propertyValue * 100
      params.CLTV = (propertyValue - downPayment) / propertyValue * 100
      params.HCLTV = (propertyValue - downPayment) / propertyValue * 100
    }else{
      params.LTV = loanAmount / propertyValue * 100
      params.CLTV = loanAmount / propertyValue * 100
      params.HCLTV = loanAmount / propertyValue * 100
    }
    if(searchBy === 'rate'){
      params.targetRate =  Number(targetPrice);
      params.targetPrice=  7;
    }else{
      params.targetRate =  100;
      params.targetPrice=  Number(targetPrice);
    }
    onRefineSearch(params);
    setChangeShowResults();
  }

  const handleLendersChange = (lenderData, selectedLenders) => {
    // console.log("result table lenders change------from api response", lenderData, selectedLenders);
    setLenderData(lenderData);
    setSelectedLenders(selectedLenders);
  }

  const svg_expand = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8107 10.5607L16.75 9.5L12.1544 14.0956L7.56066 9.50184L6.5 10.5625L11.0937 15.1562L11.0931 15.1569L12.1538 16.2175L12.1544 16.2169L12.1569 16.2194L13.2175 15.1587L13.2151 15.1563L17.8107 10.5607Z" fill="#222222"/>
      </svg>
    )
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Slider: {
            trackBg: "#f5f5f5",
            trackHoverBg: "#e6e6e6",
            railBg: "#d9d9d9",
            railHoverBg: "#bfbfbf",
            handleColor: "#1890ff",
            handleActiveColor: "#40a9ff",
            handleSize: 12,
            handleSizeHover: 14,
            dotSize: 8,
            dotActiveBorderColor: "#1890ff",
            dotBorderColor: "#d9d9d9",
            dotBg: "#fff",
            dotActiveBg: "#fff",
          },
        },
      }}
    >
      <div className="search-results" style={style}>
        {/* filter */}
        <>
          <div className="search-results-filter-title">
            <div className="search-results-filter-title-label" style={{display: "flex", alignItems: "center", gap: 8}}>
              <span>Search fields</span>
              <span className="cursor-pointer" onClick={() => handleRefineSearch()}>{svg_expand()}</span>
            </div>
            <div className="search-results-filter-title-btn cursor-pointer">
              <div
                className="search-results-filter-title-btn-item"
                onClick={() => handleRefineSearch()}
              >
                Refine search
              </div>
            </div>
          </div>
          <div className="search-results-filter">
            <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Target price/rate</span>
              </div>
              <div className="search-results-filter-item-value">
                <div className="search-results-filter-item-value-slider">
                  <Input
                    style={{width: '100%', height: 44, borderRadius: 6}}
                    type="number"
                    className="search-results-filter-item-value-slider-input"
                    prefix={searchBy === "price" ? "Price:" : "Rate:"}
                    suffix={suffix_svg()}
                    value={targetPrice}
                    onFocus={() => setIsTargetPriceFocus(true)}
                    onChange={(e) => {
                      setTargetPrice(e.target.value);
                      setTargetPriceSlider(e.target.value);
                    }}
                  />
                </div>
                <div
                  ref={targetPriceUpdateRef}
                  style={{ minWidth: "385px" }}
                  className={`search-results-filter-item-value-slider-update ${
                    isTargetPriceFocus ? "show" : "hidden"
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{padding: 16}}>
                    <div className="search-results-filter-item-value-slider-update-filter">
                      <div className="search-results-filter-item-value-slider-update-filter-label">
                        Filter by
                      </div>
                      <div className="search-results-filter-item-value-slider-update-filter-options">
                        <div
                          className={`search-results-filter-item-value-slider-update-filter-option cursor-pointer ${
                            searchByFlag === "price"
                              ? "filter-active"
                              : "filter-default"
                          }`}
                          onClick={() => {
                            if(searchByFlag === "price"){
                              setSearchByFlag("rate")
                              setTargetPrice(7)
                              setTargetPriceSlider(7)
                              setSearchBy("rate")
                            }else{
                              setSearchByFlag("price")
                              setTargetPrice(100)
                              setTargetPriceSlider(100)
                              setSearchBy("price")
                            }
                          }}
                        >
                          Price
                        </div>
                        <div
                          className={`search-results-filter-item-value-slider-update-filter-option cursor-pointer ${
                            searchByFlag === "rate"
                              ? "filter-active"
                              : "filter-default"
                          }`}
                          onClick={() => {
                            if(searchByFlag === "price"){
                              setSearchByFlag("rate")
                              setTargetPrice(7)
                              setTargetPriceSlider(7)
                              setSearchBy("rate")
                            }else{
                              setSearchByFlag("price")
                              setTargetPrice(100)
                              setTargetPriceSlider(100)
                              setSearchBy("price")
                            }
                          }}
                        >
                          Rate
                        </div>
                      </div>
                    </div>
                    <div style={{width: "94%", display: "flex", justifyContent: "center", margin: "0 auto"}}>
                      <Slider
                        className="rate-popup-slider"
                        style={{ width: "100%", margin: "69px 0 24px 0" }}
                        step={1}
                        min={searchBy === "price" ? 80 : 0}
                        max={searchBy === "price" ? 120 : 20}
                        defaultValue={targetPriceSlider}
                        value={targetPriceSlider}
                        onChange={targetPriceSliderChange}
                        tooltip={{
                          open: true,
                          formatter: (value) => {
                            return <div className="filter-tooltip">{searchByFlag === 'price' ? '' : ''}{com.commaize(value)}{searchByFlag === 'price' ? '' : '%'}</div>
                          },
                          getPopupContainer: (triggerNode) => triggerNode.parentNode,
                        }}
                      />
                    </div>
                  </div>
                  <div className="search-results-filter-item-value-slider-update-btn-divider" />
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <div
                      className="search-results-filter-item-value-slider-update-btn cursor-pointer"
                      onClick={() => {
                        setSearchBy(searchByFlag)
                        setTargetPrice(targetPriceSlider);
                        setIsTargetPriceFocus(false);
                      }}
                    >
                      Update
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Comp.type</span>
              </div>
              <div className="search-results-filter-item-value">
                <Select
                  suffixIcon={suffix_svg()}
                  style={{ width: "100%" }}
                  options={[
                    {
                      label: "Lender paid",
                      value: "lender_paid",
                    },
                    {
                      label: "Borrower paid",
                      value: "borrower_paid",
                    },
                  ]}
                  value={compType}
                  onChange={compTypeChange}
                ></Select>
              </div>
            </div>
            <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>{searchParams.purpose === 'Purchase' ? 'Property value' : 'Home value'}</span>
              </div>
              <div className="search-results-filter-item-value">
                <div className="search-results-filter-item-value-slider">
                  <InputNumber
                    className="search-results-filter-item-value-slider-input"
                    style={{width: '100%', height: 44}}
                    prefix="$"
                    controls={false}
                    suffix={suffix_svg()}
                    value={propertyValue}
                    onFocus={() => setIsPropertyValueFocus(true)}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    onChange={(value) => {
                      setPropertyValue(value);
                      setPropertyValueSlider(value);
                      if (searchParams.purpose === 'Purchase' && !SECOND_LIEN_PROGRAMS.includes(searchParams.loanProgram)) {
                        setLoanAmount(value - downPayment);
                      }
                    }}
                  />
                </div>
                <div
                  ref={propertyValueUpdateRef}
                  style={{ minWidth: "385px" }}
                  className={`search-results-filter-item-value-slider-update ${
                    isPropertyValueFocus ? "show" : "hidden"
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{padding: "16px 54px 16px 26px"}}>
                    <Slider
                      className="rate-popup-slider"
                      style={{ width: "100%", margin: "44px 0 17px 0"  }}
                      step={1}
                      min={0}
                      max={1000000}
                      defaultValue={propertyValueSlider}
                      value={propertyValueSlider}
                      onChange={propertyValueSliderChange}
                      tooltip={{
                        open: true,
                        formatter: (value) => {
                          return <div className="filter-tooltip">${com.commaize(value)}</div>
                        },
                        getPopupContainer: (triggerNode) => triggerNode.parentNode,
                      }}
                    />
                  </div>
                  <div className="search-results-filter-item-value-slider-update-btn-divider" />
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <div
                      className="search-results-filter-item-value-slider-update-btn cursor-pointer"
                      onClick={() => {
                        setPropertyValue(propertyValueSlider);
                        setIsPropertyValueFocus(false);
                        if (searchParams.purpose === 'Purchase' && !SECOND_LIEN_PROGRAMS.includes(searchParams.loanProgram)) {
                          setLoanAmount(propertyValueSlider - downPayment);
                        }
                      }}
                    >
                      Update
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {searchParams.purpose === 'Purchase' && !SECOND_LIEN_PROGRAMS.includes(searchParams.loanProgram) && <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Down payment</span>
              </div>
              <div className="search-results-filter-item-value">
                <div className="search-results-filter-item-value-slider">
                  <InputNumber
                    className="search-results-filter-item-value-slider-input"
                    style={{width: '100%', height: 44}}
                    prefix="$"
                    controls={false}
                    suffix={suffix_svg()}
                    value={downPayment}
                    onFocus={() => setIsDownPaymentFocus(true)}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    onChange={(value) => {
                      setDownPayment(value);
                      setLoanAmount(propertyValue - value);
                      setDownPaymentSlider(value);
                    }}
                  />
                </div>
                <div
                  ref={downPaymentUpdateRef}
                  style={{ minWidth: "385px" }}
                  className={`search-results-filter-item-value-slider-update ${
                    isDownPaymentFocus ? "show" : "hidden"
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{padding: "16px 54px 16px 26px"}}>
                    <Slider
                      className="rate-popup-slider"
                      style={{ width: "100%", margin: "44px 0 17px 0"  }}
                      step={1}
                      min={0}
                      max={1000000}
                      defaultValue={downPaymentSlider}
                      value={downPaymentSlider}
                      onChange={downPaymentSliderChange}
                      tooltip={{
                        open: true,
                        formatter: (value) => {
                          return <div className="filter-tooltip">${com.commaize(value)}</div>
                        },
                        getPopupContainer: (triggerNode) => triggerNode.parentNode,
                      }}
                    />
                  </div>
                  <div className="search-results-filter-item-value-slider-update-btn-divider" />
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <div
                      className="search-results-filter-item-value-slider-update-btn cursor-pointer"
                      onClick={() => {
                        setDownPayment(downPaymentSlider);
                        setLoanAmount(propertyValue - downPaymentSlider);
                        setIsDownPaymentFocus(false);
                      }}
                    >
                      Update
                    </div>
                  </div>
                </div>
              </div>
            </div>}

            {searchParams.purpose !== 'Purchase' && !SECOND_LIEN_PROGRAMS.includes(searchParams.loanProgram) && <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Loan amount</span>
              </div>
              <div className="search-results-filter-item-value">
                <div className="search-results-filter-item-value-slider">
                  <InputNumber
                    className="search-results-filter-item-value-slider-input"
                    style={{width: '100%', height: 44}}
                    prefix="$"
                    controls={false}
                    suffix={suffix_svg()}
                    value={loanAmount}
                    onFocus={() => setIsLoanAmountFocus(true)}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    onChange={(value) => {
                      setLoanAmount(value);
                      setLoanAmountSlider(value);
                    }}
                  />
                </div>
                <div
                  ref={loanAmountUpdateRef}
                  style={{ minWidth: "385px" }}
                  className={`search-results-filter-item-value-slider-update ${
                    isLoanAmountFocus ? "show" : "hidden"
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{padding: 16}}>
                    <Slider
                      className="rate-popup-slider"
                      style={{ width: "100%", margin: "44px 0 17px 0"  }}
                      step={1}
                      min={0}
                      max={1000000}
                      defaultValue={loanAmountSlider}
                      value={loanAmountSlider}
                      onChange={loanAmountSliderChange}
                      tooltip={{
                        open: true,
                        formatter: (value) => {
                          return <div className="filter-tooltip">${com.commaize(value)}</div>
                        },
                        getPopupContainer: (triggerNode) => triggerNode.parentNode,
                      }}
                    />
                  </div>
                  <div className="search-results-filter-item-value-slider-update-btn-divider" />
                  <div
                    style={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <div
                      className="search-results-filter-item-value-slider-update-btn cursor-pointer"
                      onClick={() => {
                        setLoanAmount(loanAmountSlider);
                        setIsLoanAmountFocus(false);
                      }}
                    >
                      Update
                    </div>
                  </div>
                </div>
              </div>
            </div>}
            
            <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Amortization</span>
              </div>
              <div className="search-results-filter-item-value">
                <Select
                  suffixIcon={suffix_svg()}
                  style={{ width: "100%" }}
                  value={amort}
                  onChange={amortChange}
                >
                  <option value="fixed">Fixed</option>
                  <option value="arm">ARM</option>
                </Select>
              </div>
            </div>
            <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Loan terms</span>
              </div>
              <div className="search-results-filter-item-value">
                <Select
                  suffixIcon={suffix_svg()}
                  style={{ width: "100%" }}
                  step={1}
                  defaultValue={loanTerms}
                  value={loanTerms}
                  onChange={loanTermsChange}
                >
                  {(amort === "arm" ? ARM_TERM_OPTIONS : FIXED_TERM_OPTIONS).map(({ value, label }) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="search-results-filter-item">
              <div className="search-results-filter-item-label">
                <span>Lenders</span>
              </div>
              <div className="search-results-filter-item-value">
                <Dropdown
                  trigger={["click"]}
                  overlayClassName="filter-dropdown"
                  open={openLender}
                  dropdownRender={lenderDropdownContent}
                  placement="bottomRight"
                  onOpenChange={handleLenderDropdown}
                >
                  <div className="search-results-filter-item-value-slider">
                    <div className="search-results-filter-item-value-slider-input">
                      {selectedLenders && selectedLenders.length > 0 ? (
                        <div
                          className="search-results-filter-item-border"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            className="ant-select-multiple"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <span className="ant-select-selection-item" style={{padding: "0 4px 1px 8px"}}>{selectedLenders[0]}</span>
                            {selectedLenders.length > 1 && (
                              <span className="ant-select-selection-item" style={{padding: "0 4px 1px 8px"}}>+{selectedLenders.length - 1}</span>
                            )}
                          </div>
                          <CloseOutlined
                            style={{ fontSize: 13 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              clearAll();
                            }}
                          />
                        </div>
                      ) : (
                        <div className="search-results-filter-item-border"><span>Select lenders</span>{suffix_svg()}</div>
                      )}
                    </div>
                    
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </>

        {/* result */}
        {/* <div className="search-results-result">
          <div className="search-results-result-header">
            <div className="custom-tabs">
              {tabItems.map((item) => (
                <div
                  key={item.key}
                  className={`custom-tab-item ${
                    activeTab === item.key ? "active" : ""
                  }`}
                  onClick={() => onTabChange(item.key)}
                >
                  {item.label()}
                </div>
              ))}
            </div>
            <div className="search-results-result-header-right-box">
              <div className="search-results-result-header-right-box-selected-rates">
                {selectedRates.length} selected{" "}
                <div className="clear-btn">Clear</div>
              </div>
              <div className="search-results-result-header-right-box-compare">
                <div
                  className={`search-results-result-header-right-box-compare-label ${
                    selectedRates.length > 0
                      ? "active_compare"
                      : "inactive_compare"
                  }`}
                >
                  <div>{compare_svg()}</div>
                  <span>Compare</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <RateQuoteNewResultTable 
          search={search}
          loanTypeFilter={loanTypeFilter} 
          searchParams={finalParams} 
          onLendersChange={handleLendersChange} 
          selectedLendersFromFilter={selectedLenders}
        />
      </div>
    </ConfigProvider>
  );
};

export default SearchResults;
